module.exports = __webpack_public_path__ + "img/h_app-icon.23db40a7.png";